import script from "./upload.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./upload.widget.vue?vue&type=script&lang=ts&setup=true"

import "./upload.widget.vue?vue&type=style&index=0&id=852411c4&lang=scss"

const __exports__ = script;

export default __exports__